module.exports = __webpack_public_path__ + "img/vegetable-nettles-350x184.71b6d028.jpg";